module.exports = __webpack_public_path__ + "static/media/joyable8.6cae5685.jpg";